<template>
  <div>
    <div class="table-body" style="margin-top: 20px">
      <div class="table-batch">
        <div>
          <el-button type="success" @click="addFee" style="margin-right: 10px;">
            添加
          </el-button>
        </div>
      </div>
      <div class="table-list">
        <el-table width="100%" :data="tableData" border :header-cell-style="{ textAlign: 'center' }" v-loading="loading">
          <el-table-column prop="platformName" label="平台" align="center"></el-table-column>
          <el-table-column prop="monthlyRentAmount" label="月租" align="center">
            <template slot-scope="scope">
              {{ scope.row.monthlyRentAmount+'('+scope.row.currencycode+')' }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新日期" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="primary" @click="editFee(scope.row)">编辑</el-button>
              <el-button type="danger" @click="delAdjusting(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
    <div class="page">
      <el-pagination style="margin-right:200px;" layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]" :page-size="pagesize" :current-page="currentPage" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog
      title="添加"
      :visible.sync="dialogAdjustingVisible"
      width="30%"
      @close="closeAdjusting"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="80px" class="dataForm">
        <el-form-item label="平台" prop="platformType">
          <el-select
            v-model="dataForm.platformType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in platform"
              :key="item.sellerType"
              :label="item.itemTypeName"
              :value="item.sellerType"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月租金额" prop="monthlyRentAmount">
          <el-input-number v-model="dataForm.monthlyRentAmount" size="mini" :min="0" :controls="true" controls-position="both">
          </el-input-number>
          <el-select v-model="dataForm.currencycode" placeholder="币种" filterable style="margin-left: 10px; width: 120px">
            <el-option
              v-for="item in exchangeRateList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAdjusting">取消</el-button>
        <el-button type="primary" :loading="btnAdjustingLoading" @click="submitForm('dataForm')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../../../api/api/api'
export default {
  name: 'PlatformMonthlyRentImport',
  data() {
    return {
      currentPage: 1,
      pagesize: 5,
      size: 20,
      total: 0,
      ruleForm: {
        timeType: 1,
        searchString: '',
        tongjiTime: [],
        xiugaiTime: []
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      btnLoading: false,
      listFile: [],
      returnList: [],
      errorList: '',
      btnAdjustingLoading: false,
      dialogAdjustingVisible: false,
      dataForm: {monthlyRentAmount: 0},
      rules: {
        platformType: [
          { required: true, message: '请选择平台', trigger: 'change' }
        ],
        monthlyRentAmount: [
          { required: true, message: '请输入月租金额', trigger: 'blur' }
        ],
        currencycode: [
          { required: true, message: '请选择币种', trigger: 'change' }
        ]
      },
      ids: [],
      timeInterval: [],
      exportVisible: false,
      btnExportLoading: false,
      exchangeRateList: [],
      platform: []
    }
  },
  created() {
    this.str = JSON.parse(localStorage.getItem('role'))
    this.search()
    this.getExchangeRateList()
    this.getPlatform()
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.returnList = []
      }
    }
  },
  methods: {
    // 获取汇率列表
		getExchangeRateList() {
			ajaxPost(Baseurl + 'rateController/getRatecurrencyCodeList').then((res) => {
				const { data: responseData } = res
				if (responseData.code === 200) {
					const { data } = responseData
					this.exchangeRateList = data
				}
			})
		},
    getPlatform() {
      const API = Baseurl + 'sellerController/selectPlatformList'
      const paramsData = {
        rid:this.str.rid
      }
      ajaxPost(API, paramsData).then((res) => {
        if(res.data.code === 200) {
          this.platform = res.data.data
        }else{
          this.platform=[]
          this.$message.error(res.data.data)
        }
      })
    },
    addFee() {
      this.dialogAdjustingVisible = true
    },
    editFee(row) {
      this.dialogAdjustingVisible = true
      this.dataForm = JSON.parse(JSON.stringify(row))
    },
    closeAdjusting() {
      this.dataForm = {monthlyRentAmount: 0}
      this.dialogAdjustingVisible = false
    },
    submitForm(formName) {
      if (!this.dataForm.currencycode) {
        this.$message.error('请选择币种')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnAdjustingLoading = true
          let API = Baseurl
          this.dataForm.companyId = this.str.company_id
          if (this.dataForm.id) {
            API = API + 'platformMonthlyRentalSettingsController/updatePlatformMonthlyRentalSettings'
          } else {
            API = API + 'platformMonthlyRentalSettingsController/insertPlatformMonthlyRentalSettings'
          }
          ajaxPost(API, this.dataForm).then((res) => {
            this.btnAdjustingLoading = false
            if (res.data.code === 200) {
              this.$message.success('保存成功')
              this.closeAdjusting()
              this.search()
            } else {
              this.$message.error(res.data.data)
            }
          }).catch(() => {
            this.$message.error('服务器出错')
          })
        }
      })
    },
    search() {
      this.loading = true
      // 库存列表
      var obj = {
        page: this.currentPage,
        size: this.size,
        companyId: this.str.company_id
      }
      ajaxPost(
        Baseurl + 'platformMonthlyRentalSettingsController/selectPlatformMonthlyRentalSettingPageInfo',
        obj
      ).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.size = val
      this.search()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.search()
    },
    delAdjusting(id='') {
      this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = []
        if (typeof(id) == 'number' && id) {
          ids = [id]
        } else {
          ids = this.ids
        }
        ajaxPost(Baseurl+'platformMonthlyRentalSettingsController/deletePlatformMonthlyRentalSettings', {id: ids[0]}).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            if (this.tableData.length == 1 && this.currentPage != 1) this.currentPage = this.currentPage - 1
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.data.data
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ {
  .layout .layout-section ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #b71e1e;
  }

  .el-form-item__content {
    margin-left: 0px !important;
  }

  .el-divider--horizontal {
    margin: 15px 0;
  }
}

.dataForm {
  /deep/.el-input {
    width: 70%;
    &.el-input--mini {
      width: auto;
    }
  }
}

.table-body {
	width: 100%;
	overflow: hidden;
}
.table-batch {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
	width: 100%;
	overflow: hidden;
	height: 40px;
	line-height: 40px;
	padding-left: 25px;
}

.information {
  width: 98%;
  overflow: hidden;
  margin-bottom: 50px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 300px;
  height: 300px;
}

.padding {
  padding: 5px 0;
}

.line-height {
  line-height: 35px;
}

.page {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 99;
}

.textlang {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.file-box {
  padding-top: 20px;
}
</style>
